import objectPath from 'object-path'

const getters = {
  getField: state => target => objectPath.get(state, target),
  getForm: state => ({
    ...state.form,
    perPage: state.pagination.perPage
  }),
  getActivePreset: state => state.activePreset,
  isLoading: state => state.isLoading,
  isLoadingError: state => state.isLoadingError,
  getCollection: state => state.collection,
  getPagination: state => state.pagination,
  getIncludes: state => state.includes
}

export default getters